const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const prmedia_thermatru_brochures = {

    ref : 'prmedia_thermatru_brochures',
    title : 'Explore More Tools',
    info_default_view : false,
    info_navigation_view : true,
    navigationLevel : 2,
    navigation_box : '',
    parent : 'prmedia_thermatru',
    footerdiscription : true,
    area :'PR & Media Therma-Tru',
    ContentComponents: [

        {
            navigation_ref: 'door_system',
            type: 'navigation_box',
            title: 'Door System Brochure',
            footerdiscription : true,
            discription : 'Brochures',

            buttonList: [
                {
                    title: 'Therma-Tru Thrive',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_thrive'
                },
                {
                    title: 'Why Therma-Tru',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_2022_trends'

                },
                {
                    title: 'Fiberglass vs Wood',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_enchanced_security'

                },
                {
                    title: `7'0" Door & Sidelite Solutions`,
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_2022_cat'

                },
                {
                    title: '2023 Trends and New Products',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_why'

                },
                {
                    title: 'Multi-Family Entry Door Systems',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_multi_family'

                },
                {
                    title: 'EnLiten Flush-Glazed Designs',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_impact_rated'

                },
                {
                    title: `3'6" Door Entry Solutions`,
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_smart_investment'

                },
                {
                    title: 'Complete Door System',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_fiberglass_wood'

                },
                {
                    title: 'Open to the Outdoors',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_glazed_designs'

                },
                {
                    title: `Craftsman Doors & Sidelites`,
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_sidelte'

                },
                {
                    title: `2023 Full Line Catalog`,
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_craft'

                },
                {
                    title: 'Smart Investment',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_side_solu'

                },
                {
                    title: 'Classic Craft',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_36_side_solu'

                },
                {
                    title: 'Veris Collection',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_36_side_solu1'

                },
                {
                    title: 'Pulse',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_brochures_36_side_solu2'

                },
            ]
        },

    ],
    navigationComponents: [
        // { key : 'door_system' , name: 'Door System Brochure'},

    ],

}
export const prmedia_thermatru_brochures_36_side_solu2= {
    ref : 'prmedia_thermatru_brochures_36_side_solu2',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_Pulse.pdf',
    type : 'pdf',
    title: 'Pulse',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',

}
export const prmedia_thermatru_brochures_36_side_solu1= {
    ref : 'prmedia_thermatru_brochures_36_side_solu1',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_Veris_Sprds_prmedia.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    title: 'Veris Collection',
    area :'PR & Media Therma-Tru',

}


export const prmedia_thermatru_brochures_36_side_solu = {
    ref : 'prmedia_thermatru_brochures_36_side_solu',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_ClassicCraft.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    title: 'Classic Craft',
    area :'PR & Media Therma-Tru',

}



export const prmedia_thermatru_brochures_side_solu = {
    ref : 'prmedia_thermatru_brochures_side_solu',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/22_Bro_ProductionBuilder_NHVS.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Smart Investment'
}



export const prmedia_thermatru_brochures_craft = {
    ref : 'prmedia_thermatru_brochures_craft',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_FiberglassSteel_Catalog_MAFL2023_LR (1).pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : '2023 Full Line Catalog'
}


export const prmedia_thermatru_brochures_sidelte = {
    ref : 'prmedia_thermatru_brochures_sidelte',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_CraftsmanLiteSelection.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Craftsman Doors & Sidelites'
}




export const prmedia_thermatru_brochures_glazed_designs = {
    ref : 'prmedia_thermatru_brochures_glazed_designs',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/22_Bro_PatioStormVent_HR.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Open to the Outdoors'
}


export const prmedia_thermatru_brochures_fiberglass_wood = {
    ref : 'prmedia_thermatru_brochures_fiberglass_wood',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_SystemComponents.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Complete Door System'
}


export const prmedia_thermatru_brochures_smart_investment = {
    ref : 'prmedia_thermatru_brochures_smart_investment',
    navigationLevel : -1,
    path : baseUrl+`datas/prmedia/23_Bro_3-6W-Doors.pdf`,
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : `3'6" Door Entry Solutions`
}


export const prmedia_thermatru_brochures_impact_rated = {
    ref : 'prmedia_thermatru_brochures_impact_rated',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_EnLiten_Flush-Glazed.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'EnLiten Flush-Glazed Designs'
}


export const prmedia_thermatru_brochures_multi_family = {
    ref : 'prmedia_thermatru_brochures_multi_family',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/22_Bro_MultiFamily_LR_PGS_121621.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Multi-Family Entry Door Systems'
}


export const prmedia_thermatru_brochures_why = {
    ref : 'prmedia_thermatru_brochures_why',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/2023 Trends and New Products Brochure.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : '2023 Trends and New Products'
}


export const prmedia_thermatru_brochures_2022_cat = {
    ref : 'prmedia_thermatru_brochures_2022_cat',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_7-0HeightDoors.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : `7'0" Door & Sidelite Solutions `
}


export const prmedia_thermatru_brochures_enchanced_security = {
    ref : 'prmedia_thermatru_brochures_enchanced_security',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Bro_FiberglassWoodComparison_RdrSpreads.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Fiberglass vs Wood '
}


export const prmedia_thermatru_brochures_2022_trends = {
    ref : 'prmedia_thermatru_brochures_2022_trends',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Why ThermaTru Brochure.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Why Therma-Tru'
}


export const prmedia_thermatru_brochures_thrive = {
    ref : 'prmedia_thermatru_brochures_thrive',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_TT_Bro_Thrive.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_brochures',
    area :'PR & Media Therma-Tru',
    title : 'Therma-Tru Thrive',
    
}


